import { gql } from "@apollo/client";

export const ORDER_DELIVERY_DETAIL = gql`
query Data($where: OrderDeliveryWhereInput) {
    orderDeliveryOrderGroupId(where: $where) {
      data {
        id
        sender {
          shopAddress
          fullName
          tel
          province
          district
          village
          branch
          sender_branch_id
          postcode
          address
          deliveryName
        }
        receiver {
          userAddress
          userId
          fullName
          tel
          province
          district
          village
          branch
          receive_branch_id
          postcode
          address
          deliveryName
        }
        orderTracking
        match
        deliveryTackingNo
        shipments
        createdAt
        updatedAt
        status
        delivery
        shipmentPayType
      }
      message
    }
  }
`;